export default () => {
    let textarea = document.querySelector('textarea');
    let autosize = function() {
        let el = this;
        setTimeout(function() {
            el.style.cssText = 'height: auto;';
            el.style.cssText = 'height:' + el.scrollHeight + 'px';
        }, 0)
    }
    if (textarea)
        textarea.addEventListener('keydown', autosize)
}